import React from 'react';
import Proptypes from 'prop-types';

import { getSaxsExtendedSubtractionsByExperimentId, getSaxsSubtractionsAsListByDataCollectionIds } from './IORequests';
import { parseDataCollections } from '../../../helpers/Saxs/SaxsDataCollectionMapper';

/**
 * React container which can get dataCollections. It can get them:
 * - from a list of dataCollection identifiers provided in  this.props.dataCollectionId
 * - from a list of experiment identifiers provided in  this.props.experimentId. In fact this is the list of all measurements for an experiment enriched with the information from the datacollection context
 */
class SaxsDataCollectionsContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            experimentId: null,
            dataCollectionId: null,
            fetching: true,
            fetched: false,
            dataCollections: [],
        }

        this.getDataCollections = this.getDataCollections.bind(this);
    }

    render() {
        if ((this.props.experimentId && this.state.experimentId != this.props.experimentId)
            || (this.props.dataCollectionId && this.state.dataCollectionId != this.props.dataCollectionId)) {
            this.getDataCollections();
        }
        return this.props.children(this.state.dataCollections);
    }

    /** Get all datasets associated to a given experimentId */
    getDataCollections() {
        const onSuccess = (response) => {
            const getparsedDataCollections = (data) => {
                if (this.props.experimentId) { return parseDataCollections(data) }
                if (this.props.dataCollectionId) { return parseDataCollections(data) }
            }

            this.setState({
                dataCollections: getparsedDataCollections(response.data), // store mapped data no raw data.
                experimentId: this.props.experimentId ? this.props.experimentId : null,
                dataCollectionId: this.props.dataCollectionId ? this.props.dataCollectionId : null,
                fetching: false,
                fetched: true
            });
        }

        const onError = (error) => {
            this.setState({
                error: error,
                fetching: false,
                fetched: false
            });
        }

        if (this.props.experimentId) {
            getSaxsExtendedSubtractionsByExperimentId(this.props.token, this.props.proposal, this.props.experimentId, onSuccess, onError);
        } else {
            if (this.props.dataCollectionId) {
                getSaxsSubtractionsAsListByDataCollectionIds(this.props.token, this.props.proposal, this.props.dataCollectionId, onSuccess, onError);
            }
        }
    }
}

export default SaxsDataCollectionsContainer;


SaxsDataCollectionsContainer.prototypes = {
    /** datacollection identifier. Use dataCollectionId or experimentId props */
    dataCollectionId: Proptypes.number,
    /** experiment identifier.Use dataCollectionId or experimentId props */
    experimentId: Proptypes.number,
    /** proposal name */
    proposal: Proptypes.string,
    /** ispyb backend authentication token */
    token: Proptypes.string
}


// WEBPACK FOOTER //
// ./src/containers/saxs/helpers/SaxsDataCollectionsContainer.js